import {Component, Input, OnInit} from '@angular/core';
import {IUserProfile} from '@app/store/Models/settings/settingsModel';

/**
 * A component for the user avatar. Will set initials if user has no image
 */
@Component({
    selector: 'app-avatar',
    templateUrl: './avatar.component.html',
    styleUrls: ['./avatar.component.scss'],
    standalone: false
})
export class AvatarComponent implements OnInit {

  @Input()
  userProfile: IUserProfile;

  constructor() { }

  ngOnInit(): void {
  }

  getUserInitials(): string {
    if(this.userProfile && this.userProfile.firstName && this.userProfile.lastName
      && this.userProfile.firstName.length > 0
      && this.userProfile.lastName.length > 0) {
      return this.userProfile.firstName[0].toUpperCase() + this.userProfile.lastName[0].toUpperCase()
    } else {
      return 'TI';
    }
  }
}
